import { Divider, Stack, Title } from '@mantine/core';
import Project from 'src/entities/project';
import DownloadsEnabledForReviewersSwitch from './DownloadsEnabledForReviewersSwitch/DownloadsEnabledForReviewersSwitch';
import HideCommentsForReviewersSwitch from './HideCommentsForReviewsSwitch/HideCommentsForReviewersSwitch';
import DownloadsEnabledForViewOnlySwitch from './DownloadsEnabledForViewOnlySwitch/DownloadsEnabledForViewOnlySwitch';

export type ProjectPermissionsProps = {
	project: Project;
	modalsStackOrder?: number;
	viewOnlyWithDownloads?: boolean;
	onViewOnlyWithDownloadsChange?: ( enabled: boolean ) => void;
};

const ProjectPermissions = ( {
	project, modalsStackOrder = 1, viewOnlyWithDownloads = true, onViewOnlyWithDownloadsChange
}: ProjectPermissionsProps ) => (
	<Stack spacing={0} w="100%">
		<Stack spacing={10} px={16} pb={16}>
			<Title order={4} mt={10}>Reviewer Link</Title>
			<DownloadsEnabledForReviewersSwitch project={project} />
			<HideCommentsForReviewersSwitch project={project} modalsStackOrder={modalsStackOrder} />
		</Stack>

		<Divider color="var(--color-outline-light)" />

		<Stack spacing={10} px={16} pt={16}>
			<Title order={4}>View Only Link</Title>
			<DownloadsEnabledForViewOnlySwitch
				enabled={viewOnlyWithDownloads}
				onChange={onViewOnlyWithDownloadsChange ?? ( () => {} )}
			/>
		</Stack>
	</Stack>
);

export default ProjectPermissions;
